<script setup lang="ts">
import { useTheme } from '@/composables/useTheme'
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'
import { computed } from 'vue'

const props = defineProps<Omit<ToasterProps, 'theme'>>()

const { theme } = useTheme()

const sonnerTheme = computed(() => {
    if (theme.value === 'auto') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    }
    return theme.value as 'dark' | 'light'
})
</script>

<template>
    <Sonner
        :theme="sonnerTheme"
        class="toaster group"
        v-bind="props"
        :toast-options="{
            classes: {
                toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                description: 'group-[.toast]:text-muted-foreground',
                actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
            },
        }"
    />
</template>
